import { createFileRoute, useRouteContext } from "@tanstack/react-router";

import { CreateProgramPage } from "./-components/create-program.page";

export const Route = createFileRoute("/_authenticated/org/$orgId/program/create/")({
  component: Page
});

function Page() {
  const { org } = useRouteContext({
    from: "/_authenticated/org/$orgId/program/create/"
  });
  return <CreateProgramPage org={org} />;
}
